/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminWorkflowsRouteImport } from './routes/_admin/workflows'
import { Route as AdminWebhooksRouteImport } from './routes/_admin/webhooks'
import { Route as AdminUsersRouteImport } from './routes/_admin/users'
import { Route as AdminSettingsRouteImport } from './routes/_admin/settings'
import { Route as AdminOrbEditorRouteImport } from './routes/_admin/orb-editor'
import { Route as AdminLeaderboardRouteImport } from './routes/_admin/leaderboard'
import { Route as AdminFeedbackRouteImport } from './routes/_admin/feedback'
import { Route as AdminFeatureHygieneRouteImport } from './routes/_admin/feature-hygiene'
import { Route as AdminEmailMarketingRouteImport } from './routes/_admin/email-marketing'
import { Route as AdminDashboardRouteImport } from './routes/_admin/dashboard'
import { Route as AdminOrganizationsIndexRouteImport } from './routes/_admin/organizations/index'
import { Route as AdminBillingIndexRouteImport } from './routes/_admin/billing/index'
import { Route as AdminAnnouncementsIndexRouteImport } from './routes/_admin/announcements/index'
import { Route as AdminOrganizationsOrganizationIdRouteImport } from './routes/_admin/organizations/$organizationId'
import { Route as AdminBillingRetentionRouteImport } from './routes/_admin/billing/retention'
import { Route as AdminBillingLaunchRouteImport } from './routes/_admin/billing/launch'
import { Route as AdminBillingExceptionsRouteImport } from './routes/_admin/billing/exceptions'
import { Route as AdminBillingEligibilityRouteImport } from './routes/_admin/billing/eligibility'
import { Route as AdminBillingOrganizationIdRouteImport } from './routes/_admin/billing/$organizationId'
import { Route as AdminAnnouncementsAnnouncementIdRouteImport } from './routes/_admin/announcements/$announcementId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWorkflowsRoute = AdminWorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => AdminRoute,
} as any)
const AdminWebhooksRoute = AdminWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrbEditorRoute = AdminOrbEditorRouteImport.update({
  id: '/orb-editor',
  path: '/orb-editor',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLeaderboardRoute = AdminLeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeedbackRoute = AdminFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeatureHygieneRoute = AdminFeatureHygieneRouteImport.update({
  id: '/feature-hygiene',
  path: '/feature-hygiene',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEmailMarketingRoute = AdminEmailMarketingRouteImport.update({
  id: '/email-marketing',
  path: '/email-marketing',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrganizationsIndexRoute = AdminOrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBillingIndexRoute = AdminBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnnouncementsIndexRoute = AdminAnnouncementsIndexRouteImport.update({
  id: '/announcements/',
  path: '/announcements/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrganizationsOrganizationIdRoute =
  AdminOrganizationsOrganizationIdRouteImport.update({
    id: '/organizations/$organizationId',
    path: '/organizations/$organizationId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminBillingRetentionRoute = AdminBillingRetentionRouteImport.update({
  id: '/billing/retention',
  path: '/billing/retention',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBillingLaunchRoute = AdminBillingLaunchRouteImport.update({
  id: '/billing/launch',
  path: '/billing/launch',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBillingExceptionsRoute = AdminBillingExceptionsRouteImport.update({
  id: '/billing/exceptions',
  path: '/billing/exceptions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBillingEligibilityRoute = AdminBillingEligibilityRouteImport.update({
  id: '/billing/eligibility',
  path: '/billing/eligibility',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBillingOrganizationIdRoute =
  AdminBillingOrganizationIdRouteImport.update({
    id: '/billing/$organizationId',
    path: '/billing/$organizationId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminAnnouncementsAnnouncementIdRoute =
  AdminAnnouncementsAnnouncementIdRouteImport.update({
    id: '/announcements/$announcementId',
    path: '/announcements/$announcementId',
    getParentRoute: () => AdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AdminDashboardRoute
  '/email-marketing': typeof AdminEmailMarketingRoute
  '/feature-hygiene': typeof AdminFeatureHygieneRoute
  '/feedback': typeof AdminFeedbackRoute
  '/leaderboard': typeof AdminLeaderboardRoute
  '/orb-editor': typeof AdminOrbEditorRoute
  '/settings': typeof AdminSettingsRoute
  '/users': typeof AdminUsersRoute
  '/webhooks': typeof AdminWebhooksRoute
  '/workflows': typeof AdminWorkflowsRoute
  '/announcements/$announcementId': typeof AdminAnnouncementsAnnouncementIdRoute
  '/billing/$organizationId': typeof AdminBillingOrganizationIdRoute
  '/billing/eligibility': typeof AdminBillingEligibilityRoute
  '/billing/exceptions': typeof AdminBillingExceptionsRoute
  '/billing/launch': typeof AdminBillingLaunchRoute
  '/billing/retention': typeof AdminBillingRetentionRoute
  '/organizations/$organizationId': typeof AdminOrganizationsOrganizationIdRoute
  '/announcements': typeof AdminAnnouncementsIndexRoute
  '/billing': typeof AdminBillingIndexRoute
  '/organizations': typeof AdminOrganizationsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AdminDashboardRoute
  '/email-marketing': typeof AdminEmailMarketingRoute
  '/feature-hygiene': typeof AdminFeatureHygieneRoute
  '/feedback': typeof AdminFeedbackRoute
  '/leaderboard': typeof AdminLeaderboardRoute
  '/orb-editor': typeof AdminOrbEditorRoute
  '/settings': typeof AdminSettingsRoute
  '/users': typeof AdminUsersRoute
  '/webhooks': typeof AdminWebhooksRoute
  '/workflows': typeof AdminWorkflowsRoute
  '/announcements/$announcementId': typeof AdminAnnouncementsAnnouncementIdRoute
  '/billing/$organizationId': typeof AdminBillingOrganizationIdRoute
  '/billing/eligibility': typeof AdminBillingEligibilityRoute
  '/billing/exceptions': typeof AdminBillingExceptionsRoute
  '/billing/launch': typeof AdminBillingLaunchRoute
  '/billing/retention': typeof AdminBillingRetentionRoute
  '/organizations/$organizationId': typeof AdminOrganizationsOrganizationIdRoute
  '/announcements': typeof AdminAnnouncementsIndexRoute
  '/billing': typeof AdminBillingIndexRoute
  '/organizations': typeof AdminOrganizationsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/_admin/dashboard': typeof AdminDashboardRoute
  '/_admin/email-marketing': typeof AdminEmailMarketingRoute
  '/_admin/feature-hygiene': typeof AdminFeatureHygieneRoute
  '/_admin/feedback': typeof AdminFeedbackRoute
  '/_admin/leaderboard': typeof AdminLeaderboardRoute
  '/_admin/orb-editor': typeof AdminOrbEditorRoute
  '/_admin/settings': typeof AdminSettingsRoute
  '/_admin/users': typeof AdminUsersRoute
  '/_admin/webhooks': typeof AdminWebhooksRoute
  '/_admin/workflows': typeof AdminWorkflowsRoute
  '/_admin/announcements/$announcementId': typeof AdminAnnouncementsAnnouncementIdRoute
  '/_admin/billing/$organizationId': typeof AdminBillingOrganizationIdRoute
  '/_admin/billing/eligibility': typeof AdminBillingEligibilityRoute
  '/_admin/billing/exceptions': typeof AdminBillingExceptionsRoute
  '/_admin/billing/launch': typeof AdminBillingLaunchRoute
  '/_admin/billing/retention': typeof AdminBillingRetentionRoute
  '/_admin/organizations/$organizationId': typeof AdminOrganizationsOrganizationIdRoute
  '/_admin/announcements/': typeof AdminAnnouncementsIndexRoute
  '/_admin/billing/': typeof AdminBillingIndexRoute
  '/_admin/organizations/': typeof AdminOrganizationsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dashboard'
    | '/email-marketing'
    | '/feature-hygiene'
    | '/feedback'
    | '/leaderboard'
    | '/orb-editor'
    | '/settings'
    | '/users'
    | '/webhooks'
    | '/workflows'
    | '/announcements/$announcementId'
    | '/billing/$organizationId'
    | '/billing/eligibility'
    | '/billing/exceptions'
    | '/billing/launch'
    | '/billing/retention'
    | '/organizations/$organizationId'
    | '/announcements'
    | '/billing'
    | '/organizations'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard'
    | '/email-marketing'
    | '/feature-hygiene'
    | '/feedback'
    | '/leaderboard'
    | '/orb-editor'
    | '/settings'
    | '/users'
    | '/webhooks'
    | '/workflows'
    | '/announcements/$announcementId'
    | '/billing/$organizationId'
    | '/billing/eligibility'
    | '/billing/exceptions'
    | '/billing/launch'
    | '/billing/retention'
    | '/organizations/$organizationId'
    | '/announcements'
    | '/billing'
    | '/organizations'
  id:
    | '__root__'
    | '/'
    | '/_admin'
    | '/login'
    | '/_admin/dashboard'
    | '/_admin/email-marketing'
    | '/_admin/feature-hygiene'
    | '/_admin/feedback'
    | '/_admin/leaderboard'
    | '/_admin/orb-editor'
    | '/_admin/settings'
    | '/_admin/users'
    | '/_admin/webhooks'
    | '/_admin/workflows'
    | '/_admin/announcements/$announcementId'
    | '/_admin/billing/$organizationId'
    | '/_admin/billing/eligibility'
    | '/_admin/billing/exceptions'
    | '/_admin/billing/launch'
    | '/_admin/billing/retention'
    | '/_admin/organizations/$organizationId'
    | '/_admin/announcements/'
    | '/_admin/billing/'
    | '/_admin/organizations/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/workflows': {
      id: '/_admin/workflows'
      path: '/workflows'
      fullPath: '/workflows'
      preLoaderRoute: typeof AdminWorkflowsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/webhooks': {
      id: '/_admin/webhooks'
      path: '/webhooks'
      fullPath: '/webhooks'
      preLoaderRoute: typeof AdminWebhooksRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/users': {
      id: '/_admin/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/settings': {
      id: '/_admin/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/orb-editor': {
      id: '/_admin/orb-editor'
      path: '/orb-editor'
      fullPath: '/orb-editor'
      preLoaderRoute: typeof AdminOrbEditorRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/leaderboard': {
      id: '/_admin/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof AdminLeaderboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/feedback': {
      id: '/_admin/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof AdminFeedbackRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/feature-hygiene': {
      id: '/_admin/feature-hygiene'
      path: '/feature-hygiene'
      fullPath: '/feature-hygiene'
      preLoaderRoute: typeof AdminFeatureHygieneRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/email-marketing': {
      id: '/_admin/email-marketing'
      path: '/email-marketing'
      fullPath: '/email-marketing'
      preLoaderRoute: typeof AdminEmailMarketingRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/dashboard': {
      id: '/_admin/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/organizations/': {
      id: '/_admin/organizations/'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AdminOrganizationsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/billing/': {
      id: '/_admin/billing/'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AdminBillingIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/announcements/': {
      id: '/_admin/announcements/'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof AdminAnnouncementsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/organizations/$organizationId': {
      id: '/_admin/organizations/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/organizations/$organizationId'
      preLoaderRoute: typeof AdminOrganizationsOrganizationIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/billing/retention': {
      id: '/_admin/billing/retention'
      path: '/billing/retention'
      fullPath: '/billing/retention'
      preLoaderRoute: typeof AdminBillingRetentionRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/billing/launch': {
      id: '/_admin/billing/launch'
      path: '/billing/launch'
      fullPath: '/billing/launch'
      preLoaderRoute: typeof AdminBillingLaunchRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/billing/exceptions': {
      id: '/_admin/billing/exceptions'
      path: '/billing/exceptions'
      fullPath: '/billing/exceptions'
      preLoaderRoute: typeof AdminBillingExceptionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/billing/eligibility': {
      id: '/_admin/billing/eligibility'
      path: '/billing/eligibility'
      fullPath: '/billing/eligibility'
      preLoaderRoute: typeof AdminBillingEligibilityRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/billing/$organizationId': {
      id: '/_admin/billing/$organizationId'
      path: '/billing/$organizationId'
      fullPath: '/billing/$organizationId'
      preLoaderRoute: typeof AdminBillingOrganizationIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/announcements/$announcementId': {
      id: '/_admin/announcements/$announcementId'
      path: '/announcements/$announcementId'
      fullPath: '/announcements/$announcementId'
      preLoaderRoute: typeof AdminAnnouncementsAnnouncementIdRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminEmailMarketingRoute: typeof AdminEmailMarketingRoute
  AdminFeatureHygieneRoute: typeof AdminFeatureHygieneRoute
  AdminFeedbackRoute: typeof AdminFeedbackRoute
  AdminLeaderboardRoute: typeof AdminLeaderboardRoute
  AdminOrbEditorRoute: typeof AdminOrbEditorRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminWebhooksRoute: typeof AdminWebhooksRoute
  AdminWorkflowsRoute: typeof AdminWorkflowsRoute
  AdminAnnouncementsAnnouncementIdRoute: typeof AdminAnnouncementsAnnouncementIdRoute
  AdminBillingOrganizationIdRoute: typeof AdminBillingOrganizationIdRoute
  AdminBillingEligibilityRoute: typeof AdminBillingEligibilityRoute
  AdminBillingExceptionsRoute: typeof AdminBillingExceptionsRoute
  AdminBillingLaunchRoute: typeof AdminBillingLaunchRoute
  AdminBillingRetentionRoute: typeof AdminBillingRetentionRoute
  AdminOrganizationsOrganizationIdRoute: typeof AdminOrganizationsOrganizationIdRoute
  AdminAnnouncementsIndexRoute: typeof AdminAnnouncementsIndexRoute
  AdminBillingIndexRoute: typeof AdminBillingIndexRoute
  AdminOrganizationsIndexRoute: typeof AdminOrganizationsIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminDashboardRoute: AdminDashboardRoute,
  AdminEmailMarketingRoute: AdminEmailMarketingRoute,
  AdminFeatureHygieneRoute: AdminFeatureHygieneRoute,
  AdminFeedbackRoute: AdminFeedbackRoute,
  AdminLeaderboardRoute: AdminLeaderboardRoute,
  AdminOrbEditorRoute: AdminOrbEditorRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminWebhooksRoute: AdminWebhooksRoute,
  AdminWorkflowsRoute: AdminWorkflowsRoute,
  AdminAnnouncementsAnnouncementIdRoute: AdminAnnouncementsAnnouncementIdRoute,
  AdminBillingOrganizationIdRoute: AdminBillingOrganizationIdRoute,
  AdminBillingEligibilityRoute: AdminBillingEligibilityRoute,
  AdminBillingExceptionsRoute: AdminBillingExceptionsRoute,
  AdminBillingLaunchRoute: AdminBillingLaunchRoute,
  AdminBillingRetentionRoute: AdminBillingRetentionRoute,
  AdminOrganizationsOrganizationIdRoute: AdminOrganizationsOrganizationIdRoute,
  AdminAnnouncementsIndexRoute: AdminAnnouncementsIndexRoute,
  AdminBillingIndexRoute: AdminBillingIndexRoute,
  AdminOrganizationsIndexRoute: AdminOrganizationsIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
